<template>
  <a-form :form="form" @submit.prevent="onHandleSubmit">
    <a-form-item label="Image Type" ref="form">
      <a-select
        name="type"
        v-if="types.length"
        placeholder="Select Image Type"
        size="large"
        style="max-width: 200px; width: 100%"
        v-decorator="[
          'type',
          {
            initialValue: type,
            rules: [{ required: true }]
          }
        ]"
      >
        <a-select-option
          v-for="typeItem in types"
          :key="typeItem.value"
          :value="typeItem.value"
        >
          {{ typeItem.title }}
        </a-select-option>
      </a-select>
    </a-form-item>

    <a-form-item label="Choose image">
      <a-upload
        :show-upload-list="false"
        name="image"
        list-type="picture-card"
        class="avatar-uploader"
        :beforeUpload="() => false"
        @change="onFileChange"
        v-decorator="[
          'image',
          {
            rules: [{ required: true }]
          },
        ]"
      >
        <img v-if="preview" :src="preview" alt="" />
        <div v-else>
          <a-icon type="plus" />
          <div class="ant-upload-text">
            Upload
          </div>
        </div>
      </a-upload>
    </a-form-item>

    <a-form-item label="Redirect URL">
      <a-input
        placeholder="optional"
        name="redirectUrl"
        v-decorator="['redirectUrl']"
      />
    </a-form-item>

    <div class="mt-5">
      <a-button html-type="submit" type="primary" block size="large" icon="upload"  :loading="saving">
        {{ $t('settings.uploadImage') }}
      </a-button>
    </div>
  </a-form>
</template>

<script>
export default {
  name: 'UploadImageForm',
  props: {
    types: {
      type: Array,
      required: true,
      default() {
        return []
      },
    },
    selectedType: {
      type: [String, Number],
      default() {
        return null
      },
    },
  },
  data() {
    return {
      form: this.$form.createForm(this),
      type: this.selectedType,
      img: null,
      redirectUrl: null,
      preview: null,
      saving: false,
    }
  },
  watch: {
    selectedType: function() {
      this.type = this.selectedType
    },
    img: function() {
      if (!this.img) {
        this.preview = null
        return
      }

      const reader = new FileReader()
      reader.onload = (e) => {
        this.preview = e.target.result
      }

      reader.readAsDataURL(this.img)
    },
  },
  methods: {
    onFileChange({ file }) {
      this.img = file
    },
    onHandleSubmit(e) {
      this.form.validateFields((err, values) => {
        if (err) return

        this.saving = true

        this.$store.dispatch('settings/store/UPLOAD_BANNER', {
          file: values.image.file,
          type: values.type,
          redirectUrl: values.redirectUrl,
        })
          .then(() => {
            this.$emit('saved')
          })
          .finally(() => {
            this.saving = false
          })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.ant-form-item {
  margin-bottom: 1rem;
  padding-bottom: 0;

  &-label {
    line-height: 1.5;
  }
}

.avatar-uploader {
  .ant-upload-select-picture-card {
    img {
      max-width: 100%
    }

    i {
      font-size: 32px;
      color: #999;
    }

    .ant-upload-text {
      margin-top: 8px;
      color: #666;
    }
  }
}

</style>
